export function setStateAsync(newState) {
	return new Promise((resolve, reject) => {
		this.setState(newState, resolve);
	});
}
